module.exports = __webpack_public_path__ + "img/showPicIcon.b2fb5560.png";